import PageShell from "../components/PageShell";
import PageHeader from "../components/PageHeader";
import RegrasGrid from "../components/RegrasGrid";
import { REGRAS_STAFF } from "../data/staffData";

export default function Regras() {
    return (
        <PageShell testid="page-regras">
            <PageHeader
                eyebrow="Regras da Equipe Staff"
                title="Regras Gerais"
                description="As 8 regras fundamentais que todo membro da Staff deve seguir. O descumprimento pode resultar em advertência, rebaixamento ou remoção."
            />
            <RegrasGrid
                regras={REGRAS_STAFF}
                accent="#8B5CF6"
                searchTestid="search-input-regras"
                cardPrefix="rule-card-staff"
                placeholder="Buscar regra por título ou conteúdo..."
            />
        </PageShell>
    );
}
